import axios from 'axios';
import { buildApiUrl } from '../config/api';


export const MotivosBajaService = {
    getMotivos: async (token) => {
        try {
            const response = await axios.get(
                buildApiUrl('/api/ajustes/motivosbaja'),
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            return response.data.motivos;
        } catch (error) {
            console.error('Error en MotivosBajaService:', error);
            throw error;
        }
    },
};
